/* eslint-disable @next/next/no-img-element -- favicon/external/data-URI; next/image migration impractical for these dynamic logo/signature sources */

import { Button } from '@/components/ui/button';
import { Maximize2, Minimize2 } from 'lucide-react';

interface ChatHeaderProps {
  institutionName: string;
  institutionFaviconUrl?: string;
  isFullScreen: boolean;
  isInFullScreenDialog: boolean;
  onToggleFullScreen?: () => void;
  onCloseFullScreen?: () => void;
}

export function ChatHeader({
  institutionName,
  institutionFaviconUrl,
  isFullScreen,
  isInFullScreenDialog,
  onToggleFullScreen,
  onCloseFullScreen
}: ChatHeaderProps) {
  return (
    <div className="border-border bg-card shrink-0 border-b px-4 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {/* Institution favicon */}
          {institutionFaviconUrl && (
            <img
              src={institutionFaviconUrl}
              alt={`${institutionName} icon`}
              className="h-6 w-6 object-contain"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
              }}
            />
          )}
          {/* Institution name */}
          <h3 className="text-base font-medium">{institutionName}</h3>
        </div>
        <div className="flex items-center gap-2">
          {!isFullScreen && !isInFullScreenDialog && onToggleFullScreen && (
            <Button
              variant="ghost"
              size="icon-sm"
              onClick={onToggleFullScreen}
              title="Expand to fullscreen"
            >
              <Maximize2 className="h-4 w-4" />
            </Button>
          )}
          {isInFullScreenDialog && onCloseFullScreen && (
            <Button
              variant="ghost"
              size="icon-sm"
              onClick={onCloseFullScreen}
              title="Close fullscreen"
            >
              <Minimize2 className="h-4 w-4" />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
